import { FormControl, FormHelperText, Stack, Typography, useMediaQuery } from '@mui/material'
import { FunctionComponent, SetStateAction, useState } from 'react'
import gaiaTheme from '../../../../root-components/theme'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import FormEditButtons from './form-edit-buttons'

export const FormDateInputDisplay: FunctionComponent<{
  isEditPage: boolean,
  allowEdit?: boolean,
  editField?: string | undefined,
  setEditField?: React.Dispatch<SetStateAction<any>> | undefined,
  hideEditIcon?: boolean,
  disabled: boolean,
  isLastField?: boolean,
  title: string,
  name: string,
  value: any,
  touched?: any,
  errors?: any,
  onChange: any,
  cancelEditHandler?: () => void,
  customErrorMessage?: string,
  bottomBorder?: boolean,
  topBorder?: boolean,
  sideBorders?: boolean,
  isTopRow?: boolean,
  isBottomRow?: boolean,
  monthYearOnly?: boolean,
  minDate?: any,
  maxDate?: any,
}> = ({
  isEditPage,
  allowEdit = true,
  editField,
  setEditField,
  hideEditIcon = false,
  disabled,
  isLastField = false,
  title,
  name,
  value,
  touched,
  errors,
  onChange,
  cancelEditHandler,
  customErrorMessage,
  bottomBorder = false,
  topBorder = true,
  sideBorders = true,
  isTopRow = false,
  isBottomRow = false,
  monthYearOnly = false,
  minDate,
  maxDate,
}) => {

    const [openDate, setOpenDate] = useState(false);
    const isMobileMode = useMediaQuery(gaiaTheme.breakpoints.down('md'));

    const toggleEditField = (fieldName: string) => {
      if (setEditField) {
        setEditField(fieldName)
      }
    }

    return (
      <FormControl fullWidth variant='outlined'>
        <Stack sx={{
          borderWidth: '1px',
          borderBottomStyle: bottomBorder || isBottomRow ? 'solid' : 'none',
          borderColor: 'lightGrey.main',
          borderLeftStyle: sideBorders ? 'solid' : 'none',
          borderRightStyle: sideBorders ? 'solid' : 'none',
          borderTopStyle: topBorder || isTopRow ? 'solid' : 'none',
          pt: 1, pb: 1, pl: 3,
          borderTopLeftRadius: isTopRow ? '10px' : 0,
          borderTopRightRadius: isTopRow ? '10px' : 0,
          borderBottomLeftRadius: isBottomRow ? '10px' : 0,
          borderBottomRightRadius: isBottomRow ? '10px' : 0
        }}>
          <Stack position='relative' alignItems={isMobileMode ? 'flex-start' : 'center'} flexDirection={isMobileMode ? 'column' : 'row'} justifyContent='start'>
            <Typography variant='subtitle1' sx={{ width: isMobileMode ? '100%' : '40%', minWidth: '100px', color: 'text.primary' }}> {title} </Typography>
            <Stack position='relative' flexDirection='column' sx={{ width: '100%' }}>
              <Stack position='relative' flexDirection='row' justifyContent='start' alignItems='center'>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DatePicker
                    value={value}
                    disabled={disabled}
                    onChange={onChange}
                    format={monthYearOnly ? 'MM/YYYY' : 'DD/MM/YYYY'}
                    // Order matters: MUI advances to views[index + 1] after each selection and only
                    // closes once the LAST view is chosen. With the most specific view last and
                    // openTo pointing at it, picking a day (or month) finishes and closes, while the
                    // calendar header still lets you jump up to month/year to navigate a long way.
                    // Listing day first meant picking a date then asked for month, then year.
                    views={monthYearOnly ? ['year', 'month'] : ['year', 'month', 'day']}
                    openTo={monthYearOnly ? 'month' : 'day'}
                    minDate={minDate}
                    maxDate={maxDate}
                    sx={{
                      mt: 1, mb: 1, mr: 15, ml: 1,
                      width: '100%',
                      '& .MuiOutlinedInput-root': {
                        height: '40px',
                      },
                      '& .MuiInputBase-root': { color: 'text.secondary' },
                      ...((editField !== 'startDate' || isEditPage) && {
                        '& .MuiOutlinedInput-notchedOutline': { border: 'none' }
                      }),
                      ...((editField === 'startDate' || !isEditPage) && {
                        '& .MuiOutlinedInput-notchedOutline': { borderColor: 'text.secondary' }
                      }),
                      ...(!isEditPage && {
                        mt: 1, mb: 1, mr: 2, ml: 2,
                      }),
                    }}
                    open={openDate}
                    onOpen={() => setOpenDate(true)}
                    onClose={() => setOpenDate(false)}
                    slotProps={{
                      textField: {
                        onClick: () => setOpenDate(true),
                        error: touched && Boolean(errors)
                      },
                    }}
                  />
                  {allowEdit &&
                    <FormEditButtons
                      isEditPage={isEditPage}
                      editField={editField}
                      hideEditIcon={hideEditIcon}
                      name={name}
                      toggleEditField={toggleEditField}
                      cancelEditHandler={cancelEditHandler}
                    />}
                </LocalizationProvider>
              </Stack>
              {touched && errors &&
                <FormHelperText sx={{ color: "#bf3333", marginLeft: "16px !important" }}>
                  {errors ? <div>{errors as string}</div> : null}
                </FormHelperText>
              }
              {customErrorMessage &&
                <FormHelperText sx={{ color: "#bf3333", marginLeft: "16px !important" }}>{customErrorMessage}
                </FormHelperText>
              }
            </Stack>
          </Stack>
        </Stack>
      </FormControl>
    )
  }